import { render, staticRenderFns } from "./TenantForm.vue?vue&type=template&id=be634728&scoped=true"
import script from "./TenantForm.vue?vue&type=script&lang=js"
export * from "./TenantForm.vue?vue&type=script&lang=js"
import style0 from "./TenantForm.vue?vue&type=style&index=0&id=be634728&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be634728",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be634728')) {
      api.createRecord('be634728', component.options)
    } else {
      api.reload('be634728', component.options)
    }
    module.hot.accept("./TenantForm.vue?vue&type=template&id=be634728&scoped=true", function () {
      api.rerender('be634728', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/TenantForm.vue"
export default component.exports